import { AcademyGuideCardLarge } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/academy/components/GuideCards/AcademyGuideCardLarge";
import { AcademyGuideCardSmall } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/academy/components/GuideCards/AcademyGuideCardSmall";
import { LAY_THE_GROUNDWORK } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/academy/guideData/LayTheGroundwork/index";
import { useGuidesWithLikes } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/academy/useGuidesWithLikes";
import { ExploreAllGuidesButton } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/OpenUpShopWithConfidence/ExploreAllGuidesButton";
import { IFaireAcademyGuide } from "@faire/web-api--source/indigofair/data/IFaireAcademyGuide";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const PickUpWhereYouLeftOff: React.FC<{
  guide: IFaireAcademyGuide;
  chaptersRead: number | undefined;
  totalChapters: number | undefined;
}> = ({ guide, chaptersRead, totalChapters }) => {
  const guidesWithLikes = useGuidesWithLikes();
  const relevantGuideData =
    guidesWithLikes.find(
      (guideWithLikes) => guideWithLikes.id === guide.identifier
    ) ?? LAY_THE_GROUNDWORK;
  const { isMobile } = useViewport();

  return (
    <>
      <Row justify="space-between" align="flex-end">
        <Typography
          variant={{
            mobileAndAbove: "displaySSerifRegular",
            desktopAndAbove: "displayMSerifRegular",
          }}
        >
          <StrictLocalMsg
            id="vmEFoQ"
            defaultMessage="Pick up where you left off"
            description={{
              text: "Title above card linking to pick up reading guides from where user left off",
              img: "https://cdn.faire.com/fastly/f872b4f72ab9e519a8684f1c51be51e0f86622106a05746f78fef7b0260fb40e.png",
            }}
          />
        </Typography>
        {isMobile ? null : <ExploreAllGuidesButton variant="tertiary" />}
      </Row>
      <Spacer height="4x" />
      {isMobile ? (
        <>
          <AcademyGuideCardSmall guide={relevantGuideData} />
          <Spacer height="4x" />
          <ExploreAllGuidesButton variant="secondary" />
        </>
      ) : (
        <AcademyGuideCardLarge
          guide={relevantGuideData}
          chaptersRead={chaptersRead}
          totalChapters={totalChapters}
        />
      )}
    </>
  );
};
